import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { BaseResponse } from '@services/api/api-base.service'
import { ManagementApiBaseService } from '@services/api/management-api-base.service'
import { DemandIntentDocumentAttachment, DemandIntentDocumentAttachmentStatus } from '@models/demand/demand-intent-document-attachment.model'
import { map } from 'rxjs'

@Injectable({
	providedIn: 'root'
})
export class DemandIntentDocumentAttachmentService extends ManagementApiBaseService<any> {
	private readonly source: string

	constructor(override http: HttpClient) {
		super(http)
		this.source = 'demand-intent-document-attachments'
	}

	save(entity: DemandIntentDocumentAttachment) {
		return this.post<DemandIntentDocumentAttachment, BaseResponse>(`${this.source}`, entity)
	}

	detail(id: string) {
		return this.get<DemandIntentDocumentAttachment>(`${this.source}/detail/${id}`).pipe(map(response => new DemandIntentDocumentAttachment(response)))
	}

	listable(demandId: string) {
		return this.get<DemandIntentDocumentAttachment[]>(`${this.source}/${demandId}`).pipe(
			map(response => response.map(it => new DemandIntentDocumentAttachment(it)))
		)
	}

	remove(id: string) {
		return this.delete<BaseResponse>(`${this.source}/${id}`)
	}

	recovery(id: string) {
		return this.patch(`${this.source}/${id}/recovery`)
	}

	attached(id: string) {
		return this.put<DemandIntentDocumentAttachment, BaseResponse>(
			`${this.source}/${id}`,
			new DemandIntentDocumentAttachment({
				status: DemandIntentDocumentAttachmentStatus.ATTACHED
			})
		)
	}
}
